import React, { useState } from 'react';
import { Routes, Route } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Box } from '@mui/material';
import theme from './theme/theme';
import Navbar from './components/Layout/Navbar';
import Footer from './components/Layout/Footer';
import HomePage from './components/Home/HomePage';
import AboutPage from './components/About/AboutPage';
import ContactPage from './components/Contact/ContactPage';
import ProjectManager from './components/Admin/ProjectManager';

function App() {
  const [projects, setProjects] = useState([
    {
      id: 1,
      title: "Modern Kitchen Renovation",
      shortDescription: "Complete kitchen transformation with modern appliances",
      category: "Kitchen",
      image: "https://images.unsplash.com/photo-1556909114-f6e7ad7d3136?w=800",
      budget: "$35,000",
      duration: "6 weeks",
      client: "Residential - Downtown",
      fullDescription: "Full kitchen renovation including custom cabinetry, granite countertops, new flooring, and state-of-the-art appliances.",
      features: ["Custom Cabinetry", "Granite Countertops", "LED Lighting", "Smart Appliances"],
      testimonial: "SD Solutions transformed our outdated kitchen into a modern masterpiece!",
      completedDate: "2024-09-15",
      featured: true
    },
    {
      id: 2,
      title: "Luxury Bathroom Remodel",
      shortDescription: "Spa-like bathroom with premium fixtures",
      category: "Bathroom",
      image: "https://images.unsplash.com/photo-1552321554-5fefe8c9ef14?w=800",
      budget: "$25,000",
      duration: "4 weeks",
      client: "Residential - Suburbs",
      fullDescription: "Complete bathroom renovation featuring a walk-in shower, freestanding tub, and double vanity.",
      features: ["Walk-in Shower", "Freestanding Tub", "Double Vanity", "Heated Floors"],
      testimonial: "Our bathroom now feels like a five-star hotel spa!",
      completedDate: "2024-08-20",
      featured: true
    },
    {
      id: 3,
      title: "Living Room Transformation",
      shortDescription: "Open concept living space with custom built-ins",
      category: "Living Room",
      image: "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?w=800",
      budget: "$20,000",
      duration: "3 weeks",
      client: "Residential - Uptown",
      fullDescription: "Created an open concept living space with custom entertainment center and built-in shelving.",
      features: ["Custom Built-ins", "Crown Molding", "Hardwood Flooring", "Recessed Lighting"],
      testimonial: "The team at SD Solutions exceeded our expectations!",
      completedDate: "2024-07-10",
      featured: false
    }
  ]);

  const [reviews, setReviews] = useState([
    {
      id: 1,
      name: "John Smith",
      rating: 5,
      date: "2024-10-15",
      comment: "Excellent work on our kitchen renovation! Professional and timely.",
      reply: "Thank you for your trust in SD Solutions!"
    },
    {
      id: 2,
      name: "Sarah Johnson",
      rating: 4,
      date: "2024-09-20",
      comment: "Great bathroom remodel. Very satisfied with the results.",
      reply: ""
    }
  ]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
        <Navbar />
        <Box component="main" sx={{ flexGrow: 1 }}>
          <Routes>
            <Route path="/" element={<HomePage projects={projects} />} />
            <Route path="/about" element={<AboutPage reviews={reviews} setReviews={setReviews} />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/admin" element={<ProjectManager projects={projects} setProjects={setProjects} />} />
          </Routes>
        </Box>
        <Footer />
      </Box>
    </ThemeProvider>
  );
}

export default App;